const { POST_ROUTE,
    CATEGORY_WISE_ROUTE,
    DATE_WISE_ROUTE,
    TAG_WISE_ROUTE,
    NEW_POST_ROUTE, } = require('../../../constants/articles/routes')

const { DOC_TYPE_INFO } = require('../../../constants/articles/docTypes')

const HOST = process.env.NEXT_PUBLIC_HOST

function tagLink (tag) {
    return TAG_WISE_ROUTE
        .replace(':tags', tag.replace(/\s+/g, '-'))
}

function dateLink (post) {
    const { created } = post

    const date = new Date(created)

    if (isNaN(date)) return safariDateFallback(created)

    const year = String(date.getFullYear()).padStart(4, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')

    return DATE_WISE_ROUTE
        .replace(':year', year)
        .replace(':month', month)
}

function categoryLink (post) {
    return CATEGORY_WISE_ROUTE.replace(':category', categorySlug(post))
}

function categoryLinkFromSlug (categorySlug) {
    return CATEGORY_WISE_ROUTE.replace(':category', categorySlug)
}

function postLink (post) {
    const { slug = '' } = post
    return NEW_POST_ROUTE.replace(':slug', slug)
}

function shortPostLink (slug) {
    return NEW_POST_ROUTE
        .replace(':slug', slug)
}

// Deprecated. Use shortPostLink
function postLinkFromSlugs (categorySlug, postSlug) {
    return POST_ROUTE
        .replace(':category', categorySlug)
        .replace(':slug', postSlug)
}
//

function postImage (post) {
    return postImages(post.tracking.pid)
}

function postImages (pid, type = 'mainPhoto', order) {
    const link = `${HOST}/api/photos/article/${pid}/${type}`
    return order != null
        ? `${link}?order=${order}`
        : link
}

function categorySlug (post) {
    const { docType = null } = post
    return (DOC_TYPE_INFO[docType] || {}).slug
}

function safariDateFallback (datestring) {
    const dates = datestring.split('-')
    const year = dates[0]
    const month = dates[1]

    if (isNaN(year) || isNaN(month)) return null

    return DATE_WISE_ROUTE
        .replace(':year', year)
        .replace(':month', month)
}

module.exports = {
    tagLink,
    dateLink,
    categoryLink,
    categoryLinkFromSlug,
    postLink,
    postLinkFromSlugs,
    shortPostLink,
    postImage,
    postImages,
}